export default "__VITE_ASSET__c2cdc7bb__"